import { CATEGORIES } from "@/lib/mockData";

/**
 * Pill filter row used in Tracker & Gallery.
 * options: [{ key, label }] — first option is treated as "All".
 */
export default function CategoryFilter({
    options,
    active,
    onChange,
    light = false,
    testIdPrefix = "filter",
}) {
    return (
        <div className="flex flex-wrap items-center gap-2" data-testid={`${testIdPrefix}-row`}>
            {options.map((opt) => {
                const isActive = active === opt.key;
                const cat = CATEGORIES[opt.key];
                const accent = cat?.accentBg || "bg-seedh-blue";
                return (
                    <button
                        key={opt.key}
                        onClick={() => onChange(opt.key)}
                        data-testid={`${testIdPrefix}-${opt.key}`}
                        className={`pill border transition-all ${
                            isActive
                                ? `text-white border-transparent ${accent}`
                                : light
                                  ? "bg-white/10 text-white/85 border-white/15 hover:bg-white/15"
                                  : "bg-white text-seedh-text border-seedh-border hover:bg-seedh-surface-blue"
                        }`}
                    >
                        {opt.label}
                    </button>
                );
            })}
        </div>
    );
}
